import { clsx } from 'clsx';

import type { PropsWithChildren } from 'react';

import styles from 'components/GridRow/GridRow.module.css';

type columnSize = '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '10' | '11' | '12';

export interface ColumnProps {
  size?: columnSize;
  mediumSize?: columnSize;
  startPositon?: columnSize;
  mediumStartPosition?: columnSize;
  position?: 'start' | 'center' | 'end';
}

export const Column = ({
  size,
  mediumSize,
  startPositon,
  mediumStartPosition,
  position,
  children,
}: PropsWithChildren<ColumnProps>) => {
  return (
    <div
      className={clsx(
        styles['page-grid__col'],
        size && styles[`page-grid__col-${size}`],
        mediumSize && styles[`page-grid__col-md-${mediumSize}`],
        startPositon && styles[`page-grid__col-start-position-${startPositon}`],
        mediumStartPosition && styles[`page-grid__col-md-start-position-${mediumStartPosition}`],
        position && styles[`page-grid__col-${position}`]
      )}
    >
      {children}
    </div>
  );
};
